module.exports = __webpack_public_path__ + "static/media/marni-vipclub-heart.aa468cc1.svg";